import React, { useEffect } from 'react';
import { getCustomerId } from '../../utils/cookies';
import { useResourcePermissionsStore } from '../../stores/zustand/resourcePermissionsStore';

/**
 * Fetches effective resource permissions once the Portal session is ready.
 * Refetches when customerId changes.
 */
export function ResourcePermissionsBootstrap({ children }: { children: React.ReactNode }) {
  const fetchPermissions = useResourcePermissionsStore((s) => s.fetch);
  const customerId = getCustomerId();

  useEffect(() => {
    if (!customerId) {
      return;
    }
    void fetchPermissions(customerId);
  }, [customerId, fetchPermissions]);

  return <>{children}</>;
}
